import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from '@/app/App';
import { initTelemetry } from '@/lib/telemetry';

import './styles/index.css';

function bootstrap(): void {
  initTelemetry();

  const container = document.getElementById('root');
  if (!container) throw new Error('Root element #root is missing from index.html');

  createRoot(container).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}

bootstrap();
